<ng-template [ngIf]="!item" [ngIfElse]="loadedRef">
  <div *ngIf="loading">
    <!--<app-content-card-placeholder></app-content-card-placeholder>-->
  </div>
  <app-content-not-found *ngIf="!loading" [title]="'Publication not found'"></app-content-not-found>

  <div  *ngIf="!loading">
    <section *ngFor="let pane of additionalPanes404; trackBy: trackByFn" >
      <app-pane [item]="pane"></app-pane>
    </section>
  </div>
</ng-template>

<ng-template #loadedRef>
  <section class="content-page" [class.mobile]="deviceService.isMobile()">

    <ng-template [ngIf]="justCreated">
      <aside>
        <section>
          <app-pane [item]="shareWidgetPane"></app-pane>
        </section>
      </aside>
    </ng-template>

    <article rel="main">
      <app-pane [item]="paneMain"></app-pane>
    </article>

    <aside>
      <ng-template [ngIf]="!justCreated">
        <section rel="share">
          <app-pane [item]="shareWidgetPane"></app-pane>
        </section>
      </ng-template>

      <ng-template ngFor let-item [ngForOf]="paneList" let-i="index" [ngForTrackBy]="trackByFn"
                   class="feed-item">
        <section [attr.rel]="item.rel">
          <app-pane [item]="item"></app-pane>
        </section>
      </ng-template>
    </aside>
  </section>
</ng-template>
